import { z } from "zod";
/**
 * Base ChatThread schema used across multiple endpoints
 * Also used for DELETE /api/v1/workspaces/{wsId}/chat-threads/{threadId}
 * (DELETE endpoint returns { ok: boolean } but references this model)
 */
export const ForgeChatThread = z.object({
    id: z.string(),
    title: z.string(),
    workspaceId: z.string(),
    userId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
